import {Box, HStack, Image, VStack} from '@chakra-ui/react';
import {useHalState} from '@synako/haligator';
import {useSocieteCommerciale} from '@/haligator-factory';
import {imageOptimisee} from '@/domains/mediatheque/optimisation';
import {AccueilGreeting} from './AccueilGreeting';
import {AccueilBoutonDernieresCommandes} from './AccueilBoutonDernieresCommandes';
import {AccueilCartes} from './AccueilCartes';
import {AccueilImageAmbiance} from './AccueilImageAmbiance';
import {AccueilPastilleClient} from './AccueilPastilleClient';

/**
 * Accueil : Header de l'accueil uniquement pour la version desktop (à partir de `lg`) :
 * carte d'accueil (pastille client, dernières commandes, salutation,
 * logo de la société, cartes d'action) et photo d'ambiance à droite.
 */
export const AccueilHeaderDesktop: React.FC = () => {
  const {data: societe} = useHalState(useSocieteCommerciale());

  return (
    <HStack
      display={{base: 'none', lg: 'flex'}}
      width='100%'
      px={6}
      pt='40px'
      spacing='24px'
      align='stretch'
    >
      {/* Carte d'accueil */}
      <VStack
        flex='814'
        minW={0}
        minH='280px'
        align='stretch'
        spacing='20px'
        p='25px'
        bg='white'
        borderRadius='16px'
        border='1px solid'
        borderColor='gray.light'
        boxShadow='0 1px 10px var(--chakra-colors-black-shadow_transparency_5)'
      >
        <HStack
          align='start'
          spacing='14px'
        >
          <VStack
            flex='1'
            minW={0}
            align='start'
            spacing='8px'
          >
            <HStack
              spacing='8px'
              maxW='100%'
            >
              <AccueilPastilleClient variante='carte' />
              <AccueilBoutonDernieresCommandes variante='pastille' />
            </HStack>
            <AccueilGreeting variante='carte' />
          </VStack>
          {/* Sans logo, rien : le nom de la société est déjà dans la salutation */}
          {societe?.url_logo && (
            <Box
              flexShrink={0}
              w='158px'
              h='101px'
              display='flex'
              justifyContent='flex-end'
              alignItems='flex-start'
            >
              <Image
                src={imageOptimisee(societe.url_logo, 256)}
                alt={societe.tolede.nom_commercial}
                maxW='128px'
                maxH='50px'
                objectFit='contain'
              />
            </Box>
          )}
        </HStack>
        {/* Cartes d'action de l'accueil : Cadencier, Mes listes, Mes produits de saison */}
        <AccueilCartes variante='colonne' />
      </VStack>
      <AccueilImageAmbiance variante='ordinateur' />
    </HStack>
  );
};
